import { Loader2Icon } from 'lucide-react';
import { cn } from './lib/utils';
import type { ComponentProps } from 'react';

function Spinner({ className, ...props }: ComponentProps<typeof Loader2Icon>) {
  return (
    <Loader2Icon
      aria-label="Loading"
      className={cn('text-primary animate-spin', className)}
      role="status"
      {...props}
    />
  );
}

export { Spinner };
